<template>
	<div class="slide-grid toggle-group">
		<div v-for="(option, index) in options" class="toggle-container" :class="position + ' ' + className + ((loading) ? ' disabled' : '')">
			<input type="radio" :id="name+ '_' + index" :name="name" @change="updated(option)" :value="option.name" v-model="selectedElement" :disabled="loading">
			
			<label :for="name+ '_' + index">
				<div>
					<span role="checkbox" tabindex="0" aria-checked="false" class="toggle" v-if="className=='normal'">
					  <span aria-hidden="true" class="toggle-circle-container">
					    <span class="circle_1">
					      <svg fill="none" viewBox="0 0 12 12">
					        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					      </svg>
					    </span>
					    <span class="circle_2">
					      <svg fill="currentColor" viewBox="0 0 12 12">
					        <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
					      </svg>
					    </span>
					  </span>
					</span>

					<div class="toggle-content">
						<div class="toggle-text">
							<p class="option-name">{{ option.name | prettify }}</p>
							<slot :name="'additional_' + index"></slot>
						</div>
						
						<span class="radio-circle" v-if="className='mobile'"></span>
					</div>
					<div class="clear-both"></div>
				</div>
				<loading :show="loading" variant="mini"></loading>
			</label>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'form.toggleGroup',
		data() {
			return {
				selectedElement: 'test',
				className: '',
			}
		},
		props: {
			name: {
				type: String,
				required: true,
			},
			options: {
				type: Array,
				required: true,
			},
			position: {
				type: String,
				default: 'left'
			},
			variant: {
				type: String,
				default: 'normal'
			},
			selected: {
				type: String,
			},
			loading: {
				type: Boolean,
				default: false,
			}
		},
		watch: {
			selected: function (newVal, oldVal) {
				this.selectedElement 	= newVal;
				this.className 			= this.variant;
			}
		},
		mounted() {
			this.selectedElement = this.selected;
		},
		methods: {
			updated(option) {
				var emitArr = {
					'option': this.name
				};
				Object.keys(option).forEach(function(key) {
					emitArr[key] = option[key];
				});
				this.$emit('updated', emitArr);
			}
		}
	}
</script>